import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    MenuItem,
    FormHelperText,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import DraggableDialog from '../../../ui/draggableDialog';
import { ValidDataService } from '../../../../service/validDataService';
import { toast } from 'react-toastify';
import { isLocalDev } from '../../../../utils/environment';
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { initialValuesEncounter, validationSchemaValidEncounter,  } from '../validDataFormValidationSchema';
import validLookup from '../../../../utils/validLookup';

const validEncounterForm = ({
    insert, remove, form
}) => (
    <Form>
        {
            form.values.validEncounterData.map((value, index) => (

                <Grid container spacing={2} key={index} sx={{ mt: 1, mb: 1 }}>
                    <Grid item xs={12} md={4}>
                        <Field
                            as={TextField}
                            name={`validEncounterData[${index}].name`}
                            label="Name"
                            required
                            fullWidth
                        />
                        <ErrorMessage name={`validEncounterData[${index}].name`}>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <Field
                            as={TextField}
                            name={`validEncounterData[${index}].duration`}
                            label="Duration (min)"
                            required
                            fullWidth
                        />
                        <ErrorMessage name={`validEncounterData[${index}].cost`}>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                        <FormHelperText sx={{
                            display: { sm: 'none', lg: 'block' },
                        }}>minutes</FormHelperText>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Field
                            as={TextField}
                            name={`validEncounterData[${index}].notes`}
                            label="Notes"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Field
                            as={TextField}
                            name={`validEncounterData[${index}].status`}
                            label="Status"
                            fullWidth
                            select
                        >
                            <MenuItem value={"active"}>Active</MenuItem>
                            <MenuItem value={"inactive"}>Inactive</MenuItem>
                        </Field>
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <IconButton variant='outlined'
                            color='primary'
                            type="button"
                            onClick={() => insert(form.values.validEncounterData.length, {
                                name: '', cost: '', status: validLookup.validStatus.active
                            })} // insert an empty string at a position
                        >
                            <AddCircleIcon />
                        </IconButton>
                        {form.values.validEncounterData.length > 1 && <IconButton
                            type="button"
                            onClick={() => remove(index)} // remove a friend from the list
                        >
                            <ClearIcon />

                        </IconButton>}
                    </Grid>
                </Grid>
            ))}
        {
            form.isSubmitting ? 'Saving...' : <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!form.isValid}
            >
                Create
            </Button>
        }

    </Form>
);

export default function validEncounterInputForm({ open, onClose, onRecordAdded }) {

    const handleSubmit = async (values, { resetForm }) => {

        try {
            const response = await ValidDataService.addValidEncounter({ ...values })
            const { code, message, data } = response
    
            if (code === 0) {
                toast.success(message);
                onClose();
                onRecordAdded(data);
            } else {
                toast.success(message)
            }
        } catch(error) {
            if (isLocalDev) {
                console.log(error)
            }
            onRecordAdded([]);
            toast.error('Failed to add record')
        }
    };

    return (
        <DraggableDialog title={"Add Encounter"} onClose={onClose} open={open} width={'lg'}>
            <DialogContent>
                <Formik
                    initialValues={{ validEncounterData: [initialValuesEncounter] }}
                    validationSchema={validationSchemaValidEncounter}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, isSubmitting, touched, isValid }) => (

                        <FieldArray
                            name='validEncounterData'
                            component={validEncounterForm}
                        />
                    )}
                </Formik>
            </DialogContent>
        </DraggableDialog>
    );
};